import { useState } from 'react';

export interface Step {
  title: string;
  validationFn?: () => boolean | Promise<boolean>;
}

interface UseStepperProps {
  steps: Step[];
  onComplete?: () => void;
}

export const useStepper = ({ steps, onComplete }: UseStepperProps) => {
  const [currentStep, setCurrentStep] = useState(0);

  const goToNextStep = async () => {
    const currentStepData = steps[currentStep];
    
    if (currentStepData.validationFn) {
      const isValid = await currentStepData.validationFn();
      if (!isValid) return;
    }

    if (currentStep < steps.length - 1) {
      setCurrentStep(prev => prev + 1);
    } else if (onComplete) {
      onComplete();
    }
  };

  const goToPreviousStep = () => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
    }
  };

  const goToStep = (step: number) => {
    if (step >= 0 && step < steps.length) {
      setCurrentStep(step);
    }
  };

  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === steps.length - 1;

  return {
    steps,
    currentStep,
    goToNextStep,
    goToPreviousStep,
    goToStep,
    isFirstStep,
    isLastStep,
  };
};
